class CartRemoveButton extends HTMLElement {
    constructor() {
        super(),
            this.addEventListener("click", (e) => {
                e.preventDefault(), this.closest("cart-items").updateQuantity(this.dataset.index, 0);
            });
    }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
    constructor() {
        super(),
            (this.cartJSON = document.getElementById("cart-items-json")),
            (this.parsedCart = JSON.parse(this.cartJSON.textContent)),
            (this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status")),
            (this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce((e, t) => e + parseInt(t.value), 0)),
            (this.debouncedOnChange = debounce((e) => {
                this.onChange(e);
            }, 300)),
            this.addEventListener("change", this.debouncedOnChange.bind(this)),
            document.addEventListener("click", this.focusGiftMessage.bind(this)),
            this.addEventListener("keydown", this.onInput.bind(this));
    }
    onChange(e) {
        if (e.target.classList.contains("giftbag")) {
            let t = this.parsedCart.items[e.target.dataset.index - 1].properties;
            e.target.classList.contains("giftcard-form-message") ? (t["Recipient Gift Message"] = e.target.value.replace(/\n/g, "")) : (t["Gift Message"] = e.target.value),
                this.updateGiftMessage(e.target.dataset.index, e.target.dataset.quantity, t, e.target.value, e.target);
        } else this.updateQuantity(e.target.dataset.index, e.target.value, document.activeElement.getAttribute("name"));
    }
    onInput(e) {
        if (e.target.classList.contains("giftbag")) {
            setTimeout(function () {
                e.target.nextElementSibling.nextElementSibling.querySelector(".current-count").innerText = e.target.value.length;
            }, 10);
            let t = e.target.scrollHeight + "px";
            e.target.style.height = t;
        }
    }
    getSectionsToRender() {
        return [
            { id: "main-cart-items", section: document.getElementById("main-cart-items").dataset.id, selector: ".js-contents" },
            { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
            { id: "cart-icon-bubble-mobile", section: "cart-icon-bubble", selector: ".shopify-section" },
            { id: "cart-live-region-text", section: "cart-live-region-text", selector: ".shopify-section" },
            { id: "main-cart-footer", section: document.getElementById("main-cart-footer").dataset.id, selector: ".js-contents" },
        ];
    }
    focusGiftMessage(e) {
        if (e.target && e.target.classList.contains("giftbag-edit"))
            if ((e.preventDefault(), "edit" == e.target.dataset.setting)) {
                (e.target.dataset.setting = "save"), (e.target.innerText = "Save Message"), (e.target.previousElementSibling.disabled = !1), e.target.previousElementSibling.focus();
                let t = e.target.previousElementSibling.value.length;
                e.target.previousElementSibling.setSelectionRange(t, t), e.target.nextElementSibling.classList.remove("hidden");
            } else
                this.isProfanity(e.target.previousElementSibling.value) ||
                    0 == e.target.previousElementSibling.value.length ||
                    ((e.target.dataset.setting = "edit"), (e.target.innerText = "Edit Message"), (e.target.previousElementSibling.disabled = !0), e.target.nextElementSibling.classList.add("hidden"));
    }
    updateGiftMessage(e, t, s, i, a) {
        if (this.isProfanity(i) || 0 == i.length)
            0 == i.length && a.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.classList.remove("hidden"),
                this.isProfanity(i) && a.nextElementSibling.nextElementSibling.nextElementSibling.classList.remove("hidden"),
                a.focus();
        else {
            (a.nextElementSibling.innerText = "Edit Message"), this.enableLoading(e);
            const i = JSON.stringify({ line: e, quantity: t, properties: s, sections: this.getSectionsToRender().map((e) => e.section), sections_url: window.location.pathname });
            fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body: i })
                .then((e) => e.text())
                .then((e) => {
                    const t = JSON.parse(e);
                    (this.parsedCart = t), this.classList.toggle("is-empty", 0 === t.item_count);
                    const s = document.getElementById("main-cart-footer");
                    s && s.classList.toggle("is-empty", 0 === t.item_count),
                        this.getSectionsToRender().forEach((e) => {
                            (document.getElementById(e.id).querySelector(e.selector) || document.getElementById(e.id)).innerHTML = this.getSectionInnerHTML(t.sections[e.section], e.selector);
                        }),
                        this.disableLoading();
                })
                .catch((e) => {
                    this.querySelectorAll(".loading-overlay").forEach((e) => e.classList.add("hidden")), (document.getElementById("cart-errors").textContent = window.cartStrings.error), this.disableLoading();
                });
        }
    }
    isProfanity(e) {
        let t = !1;
        return (
            [
                "$#!T",
                "$H!T",
                "$H1T",
                "$HIT",
                "@SS",
                "@SSES",
                "@SSHOLE",
                "@SS HOLE",
                "A$$",
                "A$$ES",
                "A$$HOLE",
                "A$$ HOLE",
                "ANAL",
                "ANUS",
                "ARSE",
                "ARSEHOLE",
                "ARSE HOLE",
                "ASSES",
                "ASSHOLE",
                "ASSHOLES",
                "ASS HOLE",
                "ASS HOLES",
                "BASTARD",
                "BASTARDS",
                "BASTERD",
                "BASTERDS",
                "BASTURD",
                "BASTURDS",
                "BIATCH",
                "BIATCHES",
                "BITCH",
                "BITCHES",
                "BITCHING",
                "BITCHY",
                "BLOWJOB",
                "BLOWJOBS",
                "BLOW JOB",
                "BLOW JOBS",
                "BONER",
                "BONERS",
                "BONG",
                "BONGS",
                "BULLSHIT",
                "BUMFUCK",
                "BUNGHOLE",
                "BUTTFUCK",
                "BUTTFUCKER",
                "BUTTFUCKERS",
                "BUTTHEAD",
                "BUTTHEADS",
                "BUTTHOLE",
                "BUTTHOLES",
                "BULL SHIT",
                "BUM FUCK",
                "BUNG HOLE",
                "BUTT FUCK",
                "BUTT FUCKER",
                "BUTT FUCKERS",
                "BUTT HEAD",
                "BUTT HEADS",
                "BUTT HOLE",
                "BUTT HOLES",
                "CLIT",
                "CLITORIS",
                "COCKSUCKER",
                "CORNHOLE",
                "CORNHOLES",
                "COCK SUCKER",
                "CORN HOLE",
                "CORN HOLES",
                "CRAP",
                "CRAPPY",
                "CRAPTACULAR",
                "CRAPY",
                "CUM",
                "CUMCATCHER",
                "CUM CATCHER",
                "CUMBUCKET",
                "CUMGUZZLER",
                "CUM BUCKET",
                "CUM GUZZLER",
                "CUMSHOT",
                "CUM SHOT",
                "CUNT",
                "CUNTS",
                "DAMMIT",
                "DAMN",
                "DAMNIT",
                "DAMN-IT",
                "DAMN IT",
                "DAYGO",
                "DEGO",
                "DICKHEAD",
                "DICK HEAD",
                "DICKLESS",
                "DICKWAD",
                "DICKWADS",
                "DICKWEED",
                "DICKWEEDS",
                "DICK WAD",
                "DICK WADS",
                "DICK WEED",
                "DICK WEEDS",
                "DIKE",
                "DIKES",
                "DILDO",
                "DILDOS",
                "DONKEY PUNCH",
                "DONKEY PUNCHED",
                "DONKEY PUNCHES",
                "DONKEYPUNCH",
                "DONKEYPUNCHED",
                "DONKEYPUNCHES",
                "DONKY PUNCH",
                "DONKYPUNCH",
                "DUMBASS",
                "DUMBASSES",
                "DUMBBITCH",
                "DUMBBITCHES",
                "DUMBFUCK",
                "DUMBFUCKS",
                "DUMB ASS",
                "DUMB ASSES",
                "DUMB BITCH",
                "DUMB BITCHES",
                "DUMB FUCK",
                "DUMB FUCKS",
                "DYKE",
                "DYKES",
                "EJACULATE",
                "ERECTION",
                "ERECTIONS",
                "F.U.C.K.",
                "F0NDLE",
                "F4GG0TZ",
                "FACKING",
                "FAG",
                "FAGS",
                "FAGGEY",
                "FAGGOT",
                "FAGGOTS",
                "FAGGY",
                "FAGOT",
                "FART",
                "FATASS",
                "FATASSES",
                "FATFUCK",
                "FATFUCKS",
                "FATFUCKER",
                "FATFUCKERS",
                "FAT ASS",
                "FAT ASSES",
                "FAT FUCK",
                "FAT FUCKS",
                "FAT FUCKER",
                "FAT FUCKERS",
                "FATSO",
                "FATSOS",
                "FCKING",
                "FCUK",
                "FELLATE",
                "FELLATIO",
                "FONDLE",
                "FORESKIN",
                "FORE SKIN",
                "FORNICATE",
                "FORNICATES",
                "FUCK",
                "FUCKS",
                "FUCKA",
                "FUCKABLE",
                "FUCKED",
                "FUCKEDUP",
                "FUCKED UP",
                "FUCKER",
                "FUCKERS",
                "FUCKFACE",
                "FUCKFEST",
                "FUCKHEAD",
                "FUCKHEADS",
                "FUCKHER",
                "FUCK FACE",
                "FUCK FEST",
                "FUCK HEAD",
                "FUCK HEADS",
                "FUCK HER",
                "FUCKIN",
                "FUCKING",
                "FUCKIT",
                "FUCKME",
                "FUCKOFF",
                "FUCKTARD",
                "FUCKTURD",
                "FUCK YOU",
                "FUCK OFF",
                "FUCK TARD",
                "FUCK TURD",
                "FUCK YOU",
                "FUUCK",
                "GANGBANG",
                "GANGBANGER",
                "GANG BANG",
                "GANG BANGER",
                "GODAMN",
                "GOD DAM",
                "GOD DAMIT",
                "GOD DAMN",
                "GOD DAMNED",
                "GOD DAMNIT",
                "GODAMN",
                "GODDAM",
                "GODDAMIT",
                "GODDAMN",
                "GODDAMNED",
                "GODDAMNIT",
                "HEBE",
                "HELLNO",
                "HELLYES",
                "HELL NO",
                "HELL YES",
                "HONKERS",
                "HONKEY",
                "HOOTERS",
                "HORE",
                "HORES",
                "HORNEY",
                "HORNY",
                "HORSESHIT",
                "HORSE SHIT",
                "HUSSY",
                "JACKASS",
                "JACKASSES",
                "JACKOFF",
                "JACKOFFS",
                "JERKOFF",
                "JERKOFFS",
                "JACK ASS",
                "JACK ASSES",
                "JACK OFF",
                "JACK OFFS",
                "JERK OFF",
                "JERK OFFS",
                "JISM",
                "JIZ",
                "JIZIM",
                "JIZZ",
                "JIZZED",
                "JIZZIM",
                "KICK@SS",
                "KICK @SS",
                "KIKE",
                "KIKES",
                "KNOCKERS",
                "KOON",
                "KOONS",
                "KRAP",
                "KRAPPY",
                "KUM",
                "KUNT",
                "LIMPDICK",
                "LIMP DICK",
                "MASTABATE",
                "MASTABATER",
                "MASTERBATE",
                "MASTERBLASTER",
                "MASTRABATOR",
                "MOFO",
                "MO FO",
                "MOLEST",
                "MOLESTER",
                "MOLESTOR",
                "MOTHERFUCK",
                "MOTHERFUCKER",
                "MUFFDIVE",
                "MUFFDIVER",
                "MUFFINDIVER",
                "MUFFLIKCER",
                "MOTHER FUCK",
                "MOTHER FUCKER",
                "MUFF DIVE",
                "MUFF DIVER",
                "MUFFIN DIVER",
                "MUFF LIKCER",
                "MUTHA",
                "MUTHAFUCKA",
                "MUTHAFUCKER",
                "MUTHA FUCKA",
                "MUTHA FUCKER",
                "NAZI",
                "NAZIS",
                "NEGRO",
                "NEGROS",
                "NIGER",
                "NIGERS",
                "NIGGA",
                "NIGGAS",
                "NIGGAZ",
                "NIGGAR",
                "NIGGARS",
                "NIGGER",
                "NIGGERS",
                "NIGGERZ",
                "NOOKIE",
                "NOONER",
                "ORGASIM",
                "ORGASM",
                "ORGASMS",
                "ORGASMA",
                "ORGASMIC",
                "ORGIES",
                "ORGY",
                "P|$$",
                "P|$$ED!",
                "P|$$EDOFF",
                "P|$$ED OFF",
                "P0RN",
                "PECKER",
                "PECKERS",
                "PEE",
                "PENIS",
                "PENISES",
                "PISED",
                "PISEDOFF",
                "PISED OFF",
                "PISS",
                "PISSED",
                "PISSER",
                "PISSES",
                "PISSHEAD",
                "PISS HEAD",
                "PISSING",
                "PISSY",
                "POON",
                "POONTANG",
                "POON TANG",
                "POOP",
                "POOPER",
                "PORCHMONKEY",
                "PORCHMONKEYS",
                "PORCHMONKIES",
                "PORCH MONKEY",
                "PORCH MONKEYS",
                "PORCH MONKIES",
                "PORKIN",
                "PORKING",
                "PORN",
                "PORNO",
                "PORNOGRAFX",
                "PRICK",
                "PROSTITUTE",
                "PROSTITUTES",
                "PUBIC",
                "PUNTANG",
                "PUN TANG",
                "PUSSIES",
                "PUSSY",
                "QUEEF",
                "QUEERS",
                "RAPE",
                "RAPED",
                "RAPES",
                "RAPIST",
                "RECTUM",
                "REEFER",
                "RETARD",
                "RETARDED",
                "RETART",
                "RIMJOB",
                "SANDNIGER",
                "SANDNIGERS",
                "SANDNIGGA",
                "SANDNIGGAS",
                "SANDNIGGAZ",
                "SANDNIGGAR",
                "SANDNIGGARS",
                "SANDNIGGER",
                "SANDNIGGERS",
                "SANDNIGGERZ",
                "SAND NIGER",
                "SAND NIGERS",
                "SAND NIGGA",
                "SAND NIGGAS",
                "SAND NIGGAZ",
                "SAND NIGGAR",
                "SAND NIGGARS",
                "SAND NIGGER",
                "SAND NIGGERS",
                "SAND NIGGERZ",
                "SATAN",
                "SCHLONG",
                "SCHLONGS",
                "SCROTUM",
                "SEMEN",
                "SEX",
                "SEXUAL",
                "SEXX",
                "SEXXX",
                "SEXXXUAL",
                "Shit",
                "SH!T",
                "SH*T",
                "SHAGGIN",
                "SHAGGING",
                "SHI+",
                "SHIET",
                "SHIT",
                "SHIT4BRAINS",
                "SHIT 4 BRAINS",
                "SHITE",
                "SHITED",
                "SHITEY",
                "SHITFACE",
                "SHITFORBRAINS",
                "SHIT FOR BRAINS",
                "SHITHEAD",
                "SHITHEADS",
                "SHITHOLE",
                "SHITLOAD",
                "SHIT HEAD",
                "SHIT HEADS",
                "SHIT HOLE",
                "SHIT LOAD",
                "SHITS",
                "SHITTED",
                "SHITTER",
                "SHITTIEST",
                "SHITTING",
                "SHITTS",
                "SHITTY",
                "SHITY",
                "SHIZZY",
                "SHlT",
                "SKANK",
                "SKANKWHORE",
                "SKANKYWHORE",
                "SKINFLUTE",
                "SKUM",
                "SKANK WHORE",
                "SKANKY WHORE",
                "SKIN FLUTE",
                "SKUMBAG",
                "SLANTEYE",
                "SLEEZEBAG",
                "SLEEZEBALL",
                "SLIMEBALL",
                "SLIMEBUCKET",
                "SKUM BAG",
                "SLANT EYE",
                "SLEEZE BAG",
                "SLEEZE BALL",
                "SLIME BALL",
                "SLIME BUCKET",
                "SLUT",
                "SLUTS",
                "SLUTT",
                "SLUTTING",
                "SLUTTY",
                "SMARTASS",
                "SMARTASSES",
                "SODOMITE",
                "SODOMY",
                "SONOFABITCH",
                "SONOFBITCH",
                "SON OF A BITCH",
                "SON OF BITCH",
                "SONOVABITCH",
                "SONOVA BITCH",
                "SUNOVABITCH",
                "SUNOVA BITCH",
                "SPERM",
                "SPIC",
                "SPICS",
                "SPICK",
                "SPICKS",
                "STFU",
                "TESTACLE",
                "TESTACLES",
                "TESTICLE",
                "TESTICLES",
                "THIRDLEG",
                "THIRD LEG",
                "TITS",
                "TITTIES",
                "TITTY",
                "TITTYFUCK",
                "TRAILERTRASH",
                "TITTY FUCK",
                "TRAILER TRASH",
                "TRAMP",
                "TURD",
                "TWAT",
                "UPTHEASS",
                "UPTHEBUTT",
                "UP THE ASS",
                "UP THE BUTT",
                "VAG",
                "VAGINA",
                "VAGINAS",
                "VAGINAL",
                "VULVA",
                "WAP",
                "WANKER",
                "WANKERS",
                "WEENIE",
                "WEENIES",
                "WHACKER",
                "WHITETRASH",
                "WHITE TRASH",
                "WHORE",
                "WHOREHOUSE",
                "WHORE HOUSE",
                "WHORES",
                "WOP",
                "BOOB",
                "BOOBS",
                "BOOBIES",
                "COCK",
                "COCKS",
                "DICK",
                "DICKS",
                "DICK FACE",
                "DICKFACE",
                "DRUG",
                "DRUGS",
                "FUGLY",
                "$#!t",
                "$h!t",
                "$h1t",
                "$hit",
                "@ss",
                "@sses",
                "@sshole",
                "@ss hole",
                "a$$",
                "a$$es",
                "a$$hole",
                "a$$ hole",
                "anal",
                "anus",
                "arse",
                "arsehole",
                "arse hole",
                "asses",
                "asshole",
                "assholes",
                "ass hole",
                "ass holes",
                "bastard",
                "bastards",
                "basterd",
                "basterds",
                "basturd",
                "basturds",
                "biatch",
                "biatches",
                "bitch",
                "bitches",
                "bitching",
                "bitchy",
                "blowjob",
                "blowjobs",
                "blow job",
                "blow jobs",
                "boner",
                "boners",
                "bong",
                "bongs",
                "bullshit",
                "bumfuck",
                "bunghole",
                "buttfuck",
                "buttfucker",
                "buttfuckers",
                "butthead",
                "buttheads",
                "butthole",
                "buttholes",
                "bull shit",
                "bum fuck",
                "bung hole",
                "butt fuck",
                "butt fucker",
                "butt fuckers",
                "butt head",
                "butt heads",
                "butt hole",
                "butt holes",
                "clit",
                "clitoris",
                "cocksucker",
                "cornhole",
                "cornholes",
                "cock sucker",
                "corn hole",
                "corn holes",
                "crap",
                "crappy",
                "craptacular",
                "crapy",
                "cum",
                "cumcatcher",
                "cum catcher",
                "cumbucket",
                "cumguzzler",
                "cum bucket",
                "cum guzzler",
                "cumshot",
                "cum shot",
                "cunt",
                "cunts",
                "dammit",
                "damn",
                "damnit",
                "damn-it",
                "damn it",
                "daygo",
                "dego",
                "dickhead",
                "dick head",
                "dickless",
                "dickwad",
                "dickwads",
                "dickweed",
                "dickweeds",
                "dick wad",
                "dick wads",
                "dick weed",
                "dick weeds",
                "dike",
                "dikes",
                "dildo",
                "dildos",
                "donkey punch",
                "donkey punched",
                "donkey punches",
                "donkeypunch",
                "donkeypunched",
                "donkeypunches",
                "donky punch",
                "donkypunch",
                "dumbass",
                "dumbasses",
                "dumbbitch",
                "dumbbitches",
                "dumbfuck",
                "dumbfucks",
                "dumb ass",
                "dumb asses",
                "dumb bitch",
                "dumb bitches",
                "dumb fuck",
                "dumb fucks",
                "dyke",
                "dykes",
                "ejaculate",
                "erection",
                "erections",
                "f.u.c.k.",
                "f0ndle",
                "f4gg0tz",
                "facking",
                "fag",
                "fags",
                "faggey",
                "faggot",
                "faggots",
                "faggy",
                "fagot",
                "fart",
                "fatass",
                "fatasses",
                "fatfuck",
                "fatfucks",
                "fatfucker",
                "fatfuckers",
                "fat ass",
                "fat asses",
                "fat fuck",
                "fat fucks",
                "fat fucker",
                "fat fuckers",
                "fatso",
                "fatsos",
                "fcking",
                "fcuk",
                "fellate",
                "fellatio",
                "fondle",
                "foreskin",
                "fore skin",
                "fornicate",
                "fornicates",
                "fuck",
                "fucks",
                "fucka",
                "fuckable",
                "fucked",
                "fuckedup",
                "fucked up",
                "fucker",
                "fuckers",
                "fuckface",
                "fuckfest",
                "fuckhead",
                "fuckheads",
                "fuckher",
                "fuck face",
                "fuck fest",
                "fuck head",
                "fuck heads",
                "fuck her",
                "fuckin",
                "fucking",
                "fuckit",
                "fuckme",
                "fuckoff",
                "fucktard",
                "fuckturd",
                "fuck you",
                "fuck off",
                "fuck tard",
                "fuck turd",
                "fuck you",
                "fuuck",
                "gangbang",
                "gangbanger",
                "gang bang",
                "gang banger",
                "godamn",
                "god dam",
                "god damit",
                "god damn",
                "god damned",
                "god damnit",
                "godamn",
                "goddam",
                "goddamit",
                "goddamn",
                "goddamned",
                "goddamnit",
                "hebe",
                "hellno",
                "hellyes",
                "hell no",
                "hell yes",
                "honkers",
                "honkey",
                "hooters",
                "hore",
                "hores",
                "horney",
                "horny",
                "horseshit",
                "horse shit",
                "hussy",
                "jackass",
                "jackasses",
                "jackoff",
                "jackoffs",
                "jerkoff",
                "jerkoffs",
                "jack ass",
                "jack asses",
                "jack off",
                "jack offs",
                "jerk off",
                "jerk offs",
                "jism",
                "jiz",
                "jizim",
                "jizz",
                "jizzed",
                "jizzim",
                "kick@ss",
                "kick @ss",
                "kike",
                "kikes",
                "knockers",
                "koon",
                "koons",
                "krap",
                "krappy",
                "kum",
                "kunt",
                "limpdick",
                "limp dick",
                "mastabate",
                "mastabater",
                "masterbate",
                "masterblaster",
                "mastrabator",
                "mofo",
                "mo fo",
                "molest",
                "molester",
                "molestor",
                "motherfuck",
                "motherfucker",
                "muffdive",
                "muffdiver",
                "muffindiver",
                "mufflikcer",
                "mother fuck",
                "mother fucker",
                "muff dive",
                "muff diver",
                "muffin diver",
                "muff likcer",
                "mutha",
                "muthafucka",
                "muthafucker",
                "mutha fucka",
                "mutha fucker",
                "nazi",
                "nazis",
                "negro",
                "negros",
                "niger",
                "nigers",
                "nigga",
                "niggas",
                "niggaz",
                "niggar",
                "niggars",
                "nigger",
                "niggers",
                "niggerz",
                "nookie",
                "nooner",
                "orgasim",
                "orgasm",
                "orgasms",
                "orgasma",
                "orgasmic",
                "orgies",
                "orgy",
                "p|$$",
                "p|$$ed!",
                "p|$$edoff",
                "p|$$ed off",
                "p0rn",
                "pecker",
                "peckers",
                "pee",
                "penis",
                "penises",
                "pised",
                "pisedoff",
                "pised off",
                "piss",
                "pissed",
                "pisser",
                "pisses",
                "pisshead",
                "piss head",
                "pissing",
                "pissy",
                "poon",
                "poontang",
                "poon tang",
                "poop",
                "pooper",
                "porchmonkey",
                "porchmonkeys",
                "porchmonkies",
                "porch monkey",
                "porch monkeys",
                "porch monkies",
                "porkin",
                "porking",
                "porn",
                "porno",
                "pornografx",
                "prick",
                "prostitute",
                "prostitutes",
                "pubic",
                "puntang",
                "pun tang",
                "pussies",
                "pussy",
                "queef",
                "queers",
                "rape",
                "raped",
                "rapes",
                "rapist",
                "rectum",
                "reefer",
                "retard",
                "retarded",
                "retart",
                "rimjob",
                "sandniger",
                "sandnigers",
                "sandnigga",
                "sandniggas",
                "sandniggaz",
                "sandniggar",
                "sandniggars",
                "sandnigger",
                "sandniggers",
                "sandniggerz",
                "sand niger",
                "sand nigers",
                "sand nigga",
                "sand niggas",
                "sand niggaz",
                "sand niggar",
                "sand niggars",
                "sand nigger",
                "sand niggers",
                "sand niggerz",
                "satan",
                "schlong",
                "schlongs",
                "scrotum",
                "semen",
                "sex",
                "sexual",
                "sexx",
                "sexxx",
                "sexxxual",
                "sh!t",
                "sh*t",
                "shaggin",
                "shagging",
                "shi+",
                "shiet",
                "shit",
                "shit4brains",
                "shit 4 brains",
                "shite",
                "shited",
                "shitey",
                "shitface",
                "shitforbrains",
                "shit for brains",
                "shithead",
                "shitheads",
                "shithole",
                "shitload",
                "shit head",
                "shit heads",
                "shit hole",
                "shit load",
                "shits",
                "shitted",
                "shitter",
                "shittiest",
                "shitting",
                "shitts",
                "shitty",
                "shity",
                "shizzy",
                "shlt",
                "skank",
                "skankwhore",
                "skankywhore",
                "skinflute",
                "skum",
                "skank whore",
                "skanky whore",
                "skin flute",
                "skumbag",
                "slanteye",
                "sleezebag",
                "sleezeball",
                "slimeball",
                "slimebucket",
                "skum bag",
                "slant eye",
                "sleeze bag",
                "sleeze ball",
                "slime ball",
                "slime bucket",
                "slut",
                "sluts",
                "slutt",
                "slutting",
                "slutty",
                "smartass",
                "smartasses",
                "sodomite",
                "sodomy",
                "sonofabitch",
                "sonofbitch",
                "son of a bitch",
                "son of bitch",
                "sonovabitch",
                "sonova bitch",
                "sunovabitch",
                "sunova bitch",
                "sperm",
                "spic",
                "spics",
                "spick",
                "spicks",
                "stfu",
                "testacle",
                "testacles",
                "testicle",
                "testicles",
                "thirdleg",
                "third leg",
                "tits",
                "titties",
                "titty",
                "tittyfuck",
                "trailertrash",
                "titty fuck",
                "trailer trash",
                "tramp",
                "turd",
                "twat",
                "uptheass",
                "upthebutt",
                "up the ass",
                "up the butt",
                "vag",
                "vagina",
                "vaginas",
                "vaginal",
                "vulva",
                "wap",
                "wanker",
                "wankers",
                "weenie",
                "weenies",
                "whacker",
                "whitetrash",
                "white trash",
                "whore",
                "whorehouse",
                "whore house",
                "whores",
                "wop",
                "boob",
                "boobs",
                "boobies",
                "cock",
                "cocks",
                "dick",
                "dicks",
                "dick face",
                "dickface",
                "drug",
                "drugs",
                "fugly",
            ].forEach((s) => {
                e.includes(s) && (t = !0);
            }),
            t
        );
    }
    updateQuantity(e, t, s) {
        this.enableLoading(e);
        const i = JSON.stringify({ line: e, quantity: t, sections: this.getSectionsToRender().map((e) => e.section), sections_url: window.location.pathname });
        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body: i })
            .then((e) => e.text())
            .then((t) => {
                const i = JSON.parse(t);
                (this.parsedCart = i), this.classList.toggle("is-empty", 0 === i.item_count);
                const a = document.getElementById("main-cart-footer");
                a && a.classList.toggle("is-empty", 0 === i.item_count),
                    this.getSectionsToRender().forEach((e) => {
                        (document.getElementById(e.id).querySelector(e.selector) || document.getElementById(e.id)).innerHTML = this.getSectionInnerHTML(i.sections[e.section], e.selector);
                    }),
                    this.updateLiveRegions(e, i.item_count);
                const n = document.getElementById(`CartItem-${e}`);
                n && n.querySelector(`[name="${s}"]`) && n.querySelector(`[name="${s}"]`).focus(), this.disableLoading(), window.postMessage({ type: "cart_page", action: "cart_updated" }, "*");
            })
            .catch(() => {
                this.querySelectorAll(".loading-overlay").forEach((e) => e.classList.add("hidden")), (document.getElementById("cart-errors").textContent = window.cartStrings.error), this.disableLoading();
            });
    }
    updateLiveRegions(e, t) {
        this.currentItemCount === t &&
            (document.getElementById(`Line-item-error-${e}`).querySelector(".cart-item__error-text").innerHTML = window.cartStrings.quantityError.replace("[quantity]", document.getElementById(`Quantity-${e}`).value)),
            (this.currentItemCount = t),
            this.lineItemStatusElement.setAttribute("aria-hidden", !0);
        const s = document.getElementById("cart-live-region-text");
        s.setAttribute("aria-hidden", !1),
            setTimeout(() => {
                s.setAttribute("aria-hidden", !0);
            }, 1e3);
    }
    getSectionInnerHTML(e, t) {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }
    enableLoading(e) {
        document.getElementById("main-cart-items").classList.add("cart__items--disabled"),
            this.querySelectorAll(`#CartItem-${e} .loading-overlay`).forEach((e) => e.classList.remove("hidden")),
            document.activeElement.blur(),
            this.lineItemStatusElement.setAttribute("aria-hidden", !1);
    }
    disableLoading() {
        document.getElementById("main-cart-items").classList.remove("cart__items--disabled");
    }
}
customElements.define("cart-items", CartItems);
